<template>
  <div>
    <div class="px-6">
      <div>
        <label class="text-lg font-semibold text-black mb-0"
          >Landing Page Name</label
        >
        <el-input
          placeholder="Enter Landing Page Name"
          v-model="landing"
          class="w-full mt-2"
        ></el-input>
      </div>
      <div class="mt-4">
        <label class="text-lg font-semibold text-black mb-0"
          >Banner Image</label
        >
        <el-upload
          class="upload-demo mt-2"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>
        <div class="mt-2 grid grid-cols-4 gap-4">
          <div class="relative">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp2.png"
              alt="templates"
              class="w-full h-20"
            />
            <div
              class="absolute top-0 w-5 h-5 flex items-center justify-center mr-1 mt-1 bg-primary rounded-full cursor-pointer right-0"
            >
              <feather-icon
                icon="XIcon"
                class="text-white"
                svgClasses="w-3 h-3"
              />
            </div>
          </div>
          <div class="relative">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp2.png"
              alt="templates"
              class="w-full h-20"
            />
            <div
              class="absolute top-0 w-5 h-5 flex items-center justify-center mr-1 mt-1 bg-primary rounded-full cursor-pointer right-0"
            >
              <feather-icon
                icon="XIcon"
                class="text-white"
                svgClasses="w-3 h-3"
              />
            </div>
          </div>
          <div class="relative">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp2.png"
              alt="templates"
              class="w-full h-20"
            />
            <div
              class="absolute top-0 w-5 h-5 flex items-center justify-center mr-1 mt-1 bg-primary rounded-full cursor-pointer right-0"
            >
              <feather-icon
                icon="XIcon"
                class="text-white"
                svgClasses="w-3 h-3"
              />
            </div>
          </div>
          <div class="relative">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp2.png"
              alt="templates"
              class="w-full h-20"
            />
            <div
              class="absolute top-0 w-5 h-5 flex items-center justify-center mr-1 mt-1 bg-primary rounded-full cursor-pointer right-0"
            >
              <feather-icon
                icon="XIcon"
                class="text-white"
                svgClasses="w-3 h-3"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <label class="text-lg font-semibold text-black mb-0">Content</label>
        <div class="mt-2">
          <vue-editor class="quill-height" />
        </div>
      </div>
    </div>

    <div class="flex justify-center mt-10 pb-7">
      <vs-button
        class="bgraw border-0 col-purple font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
      >
        Submit
      </vs-button>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-quill-editor";
import { mapState } from "vuex";

export default {
  data() {
    return {
      imageLimit: "",
      landing: "",
    };
  },
  components: {
    VueEditor,
  },
  computed: {
    ...mapState("landingPage", ["templateName"]),
  },
  mounted() {
    if (this.templateName == "temp2") {
      this.imageLimit = "4";
    }
    if (this.templateName == "temp3") {
      this.imageLimit = "3";
    }
    if (this.templateName == "temp4") {
      this.imageLimit = "4";
    }
    console.log(this.imageLimit, "kjhjh");
  },
};
</script>
